function GlobalViewer({ fileUrl }) {
  const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(
    fileUrl,
  )}&embedded=true`;
  return (
    <iframe
      src={viewerUrl}
      width="100%"
      height="600px"
      style={{ border: 'none' }}
      title="iFrame"
    />
  );
}

export default GlobalViewer;
